import { useControlLock, usePermissions } from '@ctcells/api'
import { useStreamOutage, useControlDisabled } from '@ctcells/realtime'

import type { ScreenAccess } from './access.ts'

/**
 * 컨테이너가 화면에 넘기는 접근 상태를 **한 곳에서** 만든다.
 *
 * 🔴 세 축이 전부 «받아 나르는 값»이다. 화면도 컨테이너도 계산하지 않는다.
 *
 * | 축              | 출처                                                            |
 * | --------------- | --------------------------------------------------------------- |
 * | `permissions`   | 세션(서버가 준 역할) — `@ctcells/api` `usePermissions()`         |
 * | `controlDisabled` | 구독 2채널 stale 판정 — `@ctcells/realtime`                    |
 * | `lockHeld`      | 제어락 보유 여부 — `@ctcells/api` `useControlLock()`(리스 보관소)      |
 *
 * ⚠ `lockHeld` 를 기본으로 `true` 로 만들지 않는다. 모르는 상태에서 버튼이 열리면
 *   그게 바로 「낙관적 활성」이다.
 * 🔴 **보관소를 여기서 읽는 이유**: 락 조회 API 가 계약에 없어(실측 2026-09-20) 보유 여부는
 *    획득 응답·409·리스 수명에서만 온다. 컨테이너마다 그 셋을 다시 엮으면 화면마다 답이 갈린다 —
 *    한 곳에서 읽어 전 화면이 같은 답을 쓴다. 인자로 넘기면 그 값이 이긴다(시험·별도 표면용).
 */
export function useScreenAccess(options: { lockHeld?: boolean } = {}): ScreenAccess {
  const permissions = usePermissions()
  const controlDisabled = useControlDisabled()
  const offline = useStreamOutage()
  const lock = useControlLock()

  return {
    permissions,
    controlDisabled,
    offline,
    lockHeld: options.lockHeld ?? lock.held,
  }
}
